import React from 'react';

interface AuthorProps {
  author: any;
  idx: number;
}

export default function Author({ author, idx }: AuthorProps) {
  return (
    <div className="mb-2 text-gray-600">
      <h3 className="text-gray-800">
        {author.name}
        <sup>{idx}</sup>
      </h3>
      <p className="text-sm">
        <sup>{idx}</sup> {author.tag}
      </p>
      {author.email ? (
        <p className="text-sm">
          <a href={`mailto:${author.email}`}>{author.email}</a>
        </p>
      ) : null}
    </div>
  );
}
